import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import { makeStyles, useTheme } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';

import FirstInfo from './FirstInfo';
import SecondInfo from './SecondInfo';
import ThirdInfo from './ThirdInfo';

import '../../../assets/css/style.css';

const useStyles = makeStyles({
    root: {
        backgroundColor: 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

const getStepHeading = () => {
    return [
        "We have eliminated the swipe feature!", 
        "Don't be shy to make the first move", 
        "Pictures are only revealed when you both feel comfortable"
    ];
}

const getStepContent = (step) => {
    switch (step) {
        case 0:
            return <FirstInfo />;
        case 1:
            return <SecondInfo />;
        case 2:
            return <ThirdInfo />;
        default:
            return 'Unknown step';
    }
}

const ProfileInfo = () => {
    const classes = useStyles();
    const stepsHeading = getStepHeading();
    const history = useHistory();
    const [activeStep, setActiveStep] = useState(0);
    
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };
    
    const handleHome = () => {
        history.push('/');
    }
    
    return (
        <div className="container">
            <div className="row-1">
                <img src="img/logo-mark.png" alt="Universe" width="50px" height="auto"/>
                <h3>Welcome to Univrs</h3>
                <h5>Where finding college romance is a step easier</h5>
            </div>
            <div className="row-2">
                <h2>{stepsHeading[activeStep]}</h2>
            </div>
            <div className="row-3">
                <MobileStepper
                    variant="dots"
                    steps={7}
                    position="static"
                    activeStep={activeStep}
                    className={classes.root} />
                {getStepContent(activeStep)}
            </div>
            <div className="row-4">
                {activeStep !== 2 ? 
                    <button onClick={handleNext} className="uni-btn">
                        Got it!
                    </button>
                    :
                    <button onClick={handleHome} className="uni-btn">
                        Let's get started!
                    </button>
                }
            </div>
        </div>
    );
}

export default ProfileInfo;